import CityList from "issara-sdk/apis/CityList_core";
import DistrictList from "issara-sdk/apis/DistrictList_core";
import ProvinceList from "issara-sdk/apis/ProvinceList_core";
import OrganizationBankAccountCreate from "issara-sdk/apis/OrganizationBankAccountCreate_apps_HRM";
import OrganizationBankAccountSerializer from "issara-sdk/types/OrganizationBankAccountSerializer_apps_HRM";
import RevenueItemList from "issara-sdk/apis/RevenueItemList_apps_HRM";
import RevenueItemSerializer from "issara-sdk/types/RevenueItemSerializer_apps_HRM";
import RevenueItemEdit from "issara-sdk/apis/RevenueItemEdit_apps_HRM";
import DeductItemList from "issara-sdk/apis/DeductItemList_apps_HRM";
import DeductItemSerializer from "issara-sdk/types/DeductItemSerializer_apps_HRM";
import DeductItemEdit from "issara-sdk/apis/DeductItemEdit_apps_HRM";
import BankList from "issara-sdk/apis/BankList_users";
import EmployeePayrollList from "issara-sdk/apis/EmployeePayrollList_apps_HRM";
import EmployeePayrollSerializer from "issara-sdk/types/EmployeePayrollSerializer_apps_HRM";
import EmployeePayrollEdit from "issara-sdk/apis/EmployeePayrollEdit_apps_HRM";
import PayrollDetailSetting from "issara-sdk/apis/PayrollDetailSettingCreate_apps_HRM";
import PayrollDetailSettingSerializer from "issara-sdk/types/PayrollDetailSettingSerializer_apps_HRM";
import PayrollDetailSettingEdit from "issara-sdk/apis/PayrollDetailSettingEdit_apps_HRM";
import SalaryPayRunList from "issara-sdk/apis/SalaryPayRunList_apps_HRM";
import SalaryPayRunEdit from "issara-sdk/apis/SalaryPayRunEdit_apps_HRM";
import SalaryPayRunConfirmPaidSalary from "issara-sdk/apis/SalaryPayRunConfirmPaidSalary_apps_HRM";
import FileToBankSerializer from "issara-sdk/types/FileToBankSerializer_apps_HRM";
import SalaryPayRunConfirmPaidSSO from "issara-sdk/apis/SalaryPayRunConfirmPaidSSO_apps_HRM";
import PaidSSOList from "issara-sdk/apis/PaidSSOList_apps_HRM";
import PaidSSOSerializer from "issara-sdk/types/PaidSSOSerializer_apps_HRM";
import SalaryPayRunReportPipelineView from "issara-sdk/apis/SalaryPayRunReportPipelineView_apps_HRM";
import TaxReportPipelineView from "issara-sdk/apis/TaxReportPipelineView_apps_HRM";
import BankPaymentFilePipelineView from "issara-sdk/apis/BankPaymentFilePipelineView_apps_HRM";
import SsoReportPipelineView from "issara-sdk/apis/SsoReportPipelineView_apps_HRM";
import EmployeePayrollPaySlip from "issara-sdk/apis/EmployeePayrollPaySlip_apps_HRM";
import SalaryPayRunRecordAccrued from "issara-sdk/apis/SalaryPayRunRecordAccrued_apps_HRM";
import UserList from "issara-sdk/apis/UserList_users";
import PayrollRecordList from "issara-sdk/apis/PayrollRecordList_apps_HRM";
import ClinicalTermSetView from "issara-sdk/apis/ClinicalTermSetView_core";
import SalaryPayRunUpdateLogList from "issara-sdk/apis/SalaryPayRunUpdateLogList_apps_HRM";

import moment, { Moment } from "moment";
import { useRef } from "react";
import {
  ActionHandler,
  BaseSeqState,
  BLC_STATUS,
  combinePdfFiles,
  GenerateActionTypes,
  generatePrefixedActions,
  MasterMapOptions,
  PickMainState,
} from "react-lib/apps/HISV3/common/CommonInterface";
import SalaryPayRunSerializer from "issara-sdk/types/SalaryPayRunSerializer_apps_HRM";
import NicknameList from "issara-sdk/apis/NicknameList_apps_REG";
import { set } from "lodash";
import { downloadFile } from "react-lib/utils/utils";

import FormPaySlip from "../pdfForm/FormPaySlip";
import getPdfMake from "react-lib/appcon/common/pdfMake";

/** ============== Type-Defining Constants =============  */
export const ACTIONS = {
  HANDLE_COUNTRY_CHANGE: "HANDLE_COUNTRY_CHANGE",
  HANDLE_PROVINCE_CHANGE: "HANDLE_PROVINCE_CHANGE",
  HANDLE_DISTRICT_CHANGE: "HANDLE_DISTRICT_CHANGE",
  HANDLE_CITY_CHANGE: "HANDLE_CITY_CHANGE",
  FETCH_LOCATION: "FETCH_LOCATION",
  HANDLE_SUBMIT_REVENUE_ITEMS: "HANDLE_SUBMIT_REVENUE_ITEMS",
  HANDLE_EDIT_REVENUE_ITEMS: "HANDLE_EDIT_REVENUE_ITEMS",
  HANDLE_SUBMIT_DEDUCT_ITEMS: "HANDLE_SUBMIT_DEDUCT_ITEMS",
  HANDLE_EDIT_DEDUCT_ITEMS: "HANDLE_EDIT_DEDUCT_ITEMS",
  FETCH_BANK_DATA: "FETCH_BANK_DATA",
  FETCH_EMPLOYEE_PAYROLL_LIST: "FETCH_EMPLOYEE_PAYROLL_LIST",
  HANDLE_EDIT_EMPLOYEE_PAYROLL: "HANDLE_EDIT_EMPLOYEE_PAYROLL",
  HANDLE_SEARCH_EMPLOYEE_PAYROLL: "HANDLE_SEARCH_EMPLOYEE_PAYROLL",
  HANDLE_SUBMIT_BANK_ACCOUNT: "HANDLE_SUBMIT_BANK_ACCOUNT",
  HANDLE_SUBMIT_DETAIL_SETTING: "HANDLE_SUBMIT_DETAIL_SETTING",
  FETCH_DETAIL_SETTING: "FETCH_DETAIL_SETTING",
  HANDLE_EDIT_DETAIL_SETTING: "HANDLE_EDIT_DETAIL_SETTING",
  FETCH_SALARY_PAY_RUN_LIST: "FETCH_SALARY_PAY_RUN_LIST",
  HANDLE_SEARCH_SALARY_PAY_RUN: "HANDLE_SEARCH_SALARY_PAY_RUN",
  HANDLE_SUBMIT_SALARY_PAY_RUN: "HANDLE_SUBMIT_SALARY_PAY_RUN",
  HANDLE_EDIT_SALARY_PAY_RUN: "HANDLE_EDIT_SALARY_PAY_RUN",
  HANDLE_DELETE_SALARY_PAY_RUN: "HANDLE_DELETE_SALARY_PAY_RUN",
  HANDLE_SUBMIT_PAID_SALARY: "HANDLE_SUBMIT_PAID_SALARY",
  HANDLE_SUBMIT_PAID_SSO: "HANDLE_SUBMIT_PAID_SSO",
  HANDLE_SALARY_PAY_RUN_REPORT: "HANDLE_SALARY_PAY_RUN_REPORT",
  HANDLE_TAX_REPORT: "HANDLE_TAX_REPORT",
  HANDLE_BANK_PAYMENT_FILE: "HANDLE_BANK_PAYMENT_FILE",
  HANDLE_SSO_REPORT: "HANDLE_SSO_REPORT",
  HANDLE_PAY_SLIP_FILE: "HANDLE_PAY_SLIP_FILE",
  HANDLE_SUBMIT_RECORD_ACCRUED: "HANDLE_SUBMIT_RECORD_ACCRUED",
  FETCH_PAID_SSO: "FETCH_PAID_SSO",
  FETCH_USER_LIST: "FETCH_USER_LIST",
  FETCH_PAYROLL_RECORD_LIST: "FETCH_PAYROLL_RECORD_LIST",
  FETCH_CLINICAL_TERM_SET_LIST: "FETCH_CLINICAL_TERM_SET_LIST",
  FETCH_SALARY_PAYRUN_UPDATE_LOG_LIST: "FETCH_SALARY_PAYRUN_UPDATE_LOG_LIST",
} as const;

export const SEQUENCE_NAME = "Payroll" as const;

/** =============== Types and Interfaces ===============  */
export type State = Partial<{
  PayrollSequence: Partial<{
    sequenceIndex: "Action" | "START" | null;
    filter: FilterType;

    country: string | null;
    countryList: any[] | null;
    province: string | null;
    provinceList: any[];
    district: string | null;
    districtList: any[];
    city: string | null;
    cityList: any[];
    zipcode: string;
    bankAccountType: string | null;
    division: string | null;
    positionAll: string | null;
    bankAccount: any[] | null;
    revenueItems: any[] | null;
    deductItems: any[] | null;
    bank: string | null;
    bankList: string | null;
    employeePayroll: any[] | null;
    employeePayrollList: any[] | null;
    detailSetting: any[] | null;
    salaryPayRunList: any[] | null;
    salaryPayRun: any[] | null;
    searchResultSummary: any;
    searchResultEmployeePayrollList: any;
    paidSalaryData: any[] | any;
    paidSSOList: any[] | any;
    paidSSOData: any[] | any;
    accruedData: any[] | any;
    userList: any[] | any;
    payrollRecordList: any[] | any;
    clinicalTermSetList: any[] | any;
    salaryPayRunUpdateLogList: any[] | any;
  }> | null;
}>;

export type HolidaysType = {
  allDay?: boolean;
  end: Moment;
  resource?: any;
  start: Moment;
  title: string;
};

export type PickedState = PickMainState<
  | "buttonLoadCheck"
  | "errorMessage"
  | "successMessage"
  | "searchedItemListWithKey"
  | "selectedDivision"
>;

type FilterType = Partial<{ division: number; employee: number | null }>;

export type Event =
  | { message: "GetMasterData"; params: Record<string, unknown> }
  | { message: "RunSequence"; params: Record<string, unknown> };

export type Data = {
  device?: number;
  division?: number;
};

export type SeqState = BaseSeqState<SequenceName>;

export type Actions = typeof ACTIONS;

type SequenceName = typeof SEQUENCE_NAME;

type ActionPayloadMap = {
  [ACTIONS.HANDLE_COUNTRY_CHANGE]: { country: string };
  [ACTIONS.HANDLE_PROVINCE_CHANGE]: { province: string };
  [ACTIONS.HANDLE_DISTRICT_CHANGE]: { district: string };
  [ACTIONS.HANDLE_CITY_CHANGE]: { city: string };
  [ACTIONS.FETCH_LOCATION]: { country: any; province: any; district: any };
  [ACTIONS.HANDLE_SUBMIT_BANK_ACCOUNT]: { account: any };
  [ACTIONS.HANDLE_SUBMIT_REVENUE_ITEMS]: { item: any };
  [ACTIONS.HANDLE_EDIT_REVENUE_ITEMS]: { item: any };
  [ACTIONS.HANDLE_SUBMIT_DEDUCT_ITEMS]: { item: any };
  [ACTIONS.HANDLE_EDIT_DEDUCT_ITEMS]: { item: any };
  [ACTIONS.HANDLE_SUBMIT_DETAIL_SETTING]: { setting: any };
  [ACTIONS.FETCH_DETAIL_SETTING]: {};
  [ACTIONS.HANDLE_EDIT_DETAIL_SETTING]: { setting: any };
  [ACTIONS.FETCH_BANK_DATA]: {};
  [ACTIONS.FETCH_EMPLOYEE_PAYROLL_LIST]: {
    startDate: any;
    endDate: any;
    department: any;
    position: any;
    salaryPayRun: any;
  };
  [ACTIONS.HANDLE_EDIT_EMPLOYEE_PAYROLL]: {
    item: Partial<EmployeePayrollSerializer> & { id: number };
  };
  [ACTIONS.HANDLE_SEARCH_EMPLOYEE_PAYROLL]: {
    salaryPayRun: any;
  };
  [ACTIONS.FETCH_SALARY_PAY_RUN_LIST]: {};
  [ACTIONS.HANDLE_SEARCH_SALARY_PAY_RUN]: {
    payRunCode: any;
    issuedDateStart: any;
    issuedDateEnd: any;
    status: any;
    onlyAccrued: any;
  };
  [ACTIONS.HANDLE_SUBMIT_SALARY_PAY_RUN]: { salaryPayRun: any };
  [ACTIONS.HANDLE_EDIT_SALARY_PAY_RUN]: { salaryPayRun: any };
  [ACTIONS.HANDLE_DELETE_SALARY_PAY_RUN]: { salaryPayRun: any };
  [ACTIONS.HANDLE_SUBMIT_PAID_SALARY]: { paidSalaryData: any };
  [ACTIONS.HANDLE_SUBMIT_PAID_SSO]: { paidSSOData: any };
  [ACTIONS.HANDLE_SALARY_PAY_RUN_REPORT]: { salaryPayRun: any };
  [ACTIONS.HANDLE_TAX_REPORT]: { salaryPayRun: any };
  [ACTIONS.HANDLE_BANK_PAYMENT_FILE]: {
    salaryPayRun: any;
    paymentDate: any;
  };
  [ACTIONS.HANDLE_SSO_REPORT]: {
    salaryPayRun: any;
    ssoDueDate: any;
  };
  [ACTIONS.HANDLE_PAY_SLIP_FILE]: {
    employeePayroll: any;
    language: any;
  };
  [ACTIONS.HANDLE_SUBMIT_RECORD_ACCRUED]: { salaryPayRunId: any; accruedData: any };
  [ACTIONS.FETCH_PAID_SSO]: { pk?: number | string };
  [ACTIONS.FETCH_USER_LIST]: { pk?: number | string };
  [ACTIONS.FETCH_PAYROLL_RECORD_LIST]: {};
  [ACTIONS.FETCH_CLINICAL_TERM_SET_LIST]: {};
  [ACTIONS.FETCH_SALARY_PAYRUN_UPDATE_LOG_LIST]: { salaryPayRun: any };
};

type ActionTypes = GenerateActionTypes<
  Actions,
  ActionPayloadMap,
  SequenceName,
  PickedState & State
>;

type ActionType = ActionTypes["ActionType"];

export type RunSequence = ActionTypes["RunSequence"];

export type SetProp = ActionTypes["SetProp"];

export type OnEvent = ActionTypes["OnEvent"];

type Params<A extends ActionType["action"]> = ActionTypes["Params"][A];

export type Handler<P = unknown, R = void> = ActionHandler<PickedState & State, Event, Data, P, R>;

/** ===================== Constants ====================  */
export const StateInitial: State = {
  PayrollSequence: null,
};

export const DataInitial: Data = {};

const Masters = [
  ["country", {}],
  ["province", {}],
  ["bankAccountType", {}],
  ["positionAll", {}],
  ["division", {}],
  ["employmentType", {}],
] as const;

type Optional<T> = {
  [K in keyof T]: `${typeof CARD_NAME}_${T[K] & string}`;
};

export const CARD_NAME = "CardPayroll";

export const BTN_ACTS = Object.fromEntries(
  Object.keys(ACTIONS).map((key) => [key, `${CARD_NAME}_${key}`])
) as Optional<typeof ACTIONS>;

/** ===================== Functions ====================  */
export const Start: Handler<SeqState> = async (controller, params) => {
  const state = controller.getState();

  controller.handleEvent({ message: "GetMasterData", params: { masters: Masters } });

  FetchBankAccountData(controller);
  await FetchLocation(controller, {
    country: state?.PayrollSequence?.country ?? null,
    province: state?.PayrollSequence?.province ?? null,
    district: state?.PayrollSequence?.district ?? null,
  });
  FetchRevenueItems(controller);
  FetchDeductItems(controller);
  FetchBankList(controller);
  FetchSalaryPayRunList(controller);
  FetchDetailSetting(controller);
  FetchPaidSalary(controller, {});
  FetchPayrollRecordList(controller, {
    sequence: "Payroll",
    action: "FETCH_PAYROLL_RECORD_LIST",
  });
  FetchClinicalTermSetList(controller, {
    sequence: "Payroll",
    action: "FETCH_CLINICAL_TERM_SET_LIST",
  });

  controller.setState(
    {
      PayrollSequence: {
        ...state.PayrollSequence,
        sequenceIndex: "Action",
        division: state.selectedDivision?.id,
      },
    },
    () => {}
  );
};

/** ====================================================  */
/**                        Action                         */
/** ====================================================  */

export const Action: Handler<ActionType> = async (controller, params) => {
  const actionHandlers: Partial<{ [K in ActionType["action"]]: Handler<Params<K>> }> = {
    [ACTIONS.HANDLE_COUNTRY_CHANGE]: HandleCountryChange,
    [ACTIONS.HANDLE_PROVINCE_CHANGE]: HandleProvinceChange,
    [ACTIONS.HANDLE_DISTRICT_CHANGE]: HandleDistrictChange,
    [ACTIONS.HANDLE_CITY_CHANGE]: HandleCityChange,
    [ACTIONS.FETCH_LOCATION]: FetchLocation,
    [ACTIONS.HANDLE_SUBMIT_REVENUE_ITEMS]: HandleSubmitRevenueItem,
    [ACTIONS.HANDLE_EDIT_REVENUE_ITEMS]: HandleEditRevenueItem,
    [ACTIONS.HANDLE_SUBMIT_DEDUCT_ITEMS]: HandleSubmitDeductItem,
    [ACTIONS.HANDLE_EDIT_DEDUCT_ITEMS]: HandleEditDeductItem,
    [ACTIONS.FETCH_BANK_DATA]: FetchBankList,
    [ACTIONS.FETCH_EMPLOYEE_PAYROLL_LIST]: FetchEmployeePayrollList,
    [ACTIONS.HANDLE_EDIT_EMPLOYEE_PAYROLL]: HandleEditEmployeePayroll,
    [ACTIONS.HANDLE_SEARCH_EMPLOYEE_PAYROLL]: HandleSearchEmployeePayroll,
    [ACTIONS.HANDLE_SUBMIT_BANK_ACCOUNT]: HandleSubmitBankAccount,
    [ACTIONS.HANDLE_SUBMIT_DETAIL_SETTING]: HandleSubmitDetailSetting,
    [ACTIONS.FETCH_DETAIL_SETTING]: FetchDetailSetting,
    [ACTIONS.HANDLE_EDIT_DETAIL_SETTING]: HandleEditDetailSetting,
    [ACTIONS.FETCH_SALARY_PAY_RUN_LIST]: FetchSalaryPayRunList,
    [ACTIONS.HANDLE_SEARCH_SALARY_PAY_RUN]: HandleSearchSalaryPayRun,
    [ACTIONS.HANDLE_SUBMIT_SALARY_PAY_RUN]: HandleSubmitSalaryPayRun,
    [ACTIONS.HANDLE_EDIT_SALARY_PAY_RUN]: HandleEditSalaryPayRun,
    [ACTIONS.HANDLE_DELETE_SALARY_PAY_RUN]: HandleDeleteSalaryPayRun,
    [ACTIONS.HANDLE_SUBMIT_PAID_SALARY]: HandleSubmitPaidSalary,
    [ACTIONS.HANDLE_SUBMIT_PAID_SSO]: HandleSubmitPaidSSO,
    [ACTIONS.HANDLE_SALARY_PAY_RUN_REPORT]: HandleSalaryPayRunReport,
    [ACTIONS.HANDLE_TAX_REPORT]: HandleTaxReport,
    [ACTIONS.HANDLE_BANK_PAYMENT_FILE]: HandleBankPaymentFile,
    [ACTIONS.HANDLE_SSO_REPORT]: HandleSSOReport,
    [ACTIONS.HANDLE_PAY_SLIP_FILE]: HandlePaySlipFile,
    [ACTIONS.HANDLE_SUBMIT_RECORD_ACCRUED]: HandleSubmitRecordAccrued,
    [ACTIONS.FETCH_PAID_SSO]: FetchPaidSSO,
    [ACTIONS.FETCH_USER_LIST]: FetchUserList,
    [ACTIONS.FETCH_PAYROLL_RECORD_LIST]: FetchPayrollRecordList,
    [ACTIONS.FETCH_CLINICAL_TERM_SET_LIST]: FetchClinicalTermSetList,
    [ACTIONS.FETCH_SALARY_PAYRUN_UPDATE_LOG_LIST]: FetchSalaryPayRunUpdateLogList,
  };

  const { action } = params;

  const handler = actionHandlers[action] as Handler<Params<typeof action>> | undefined;

  if (handler) {
    handler(controller, params);
  } else {
    console.error(`No handler found for action: ${action}`);
  }
};

/** ====================================================  */
/**                        Handler                        */
/** ====================================================  */

const HandleCountryChange: Handler<Params<Actions["HANDLE_COUNTRY_CHANGE"]>> = async (
  controller,
  params
) => {
  const selectedCountry = params.country;
  const provinceList = await getProvinceList(controller, selectedCountry);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      country: selectedCountry,
      province: null,
      provinceList: provinceList,
      district: null,
      districtList: null,
      city: null,
      cityList: null,
      zipcode: null,
    },
  }));
};

const HandleProvinceChange: Handler<Params<Actions["HANDLE_PROVINCE_CHANGE"]>> = async (
  controller,
  params
) => {
  const selectedProvince = params.province;
  const districtList = await getDistrictList(controller, selectedProvince);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      province: selectedProvince,
      district: null,
      districtList: districtList,
      city: null,
      cityList: null,
      zipcode: null,
    },
  }));
};

const HandleDistrictChange: Handler<Params<Actions["HANDLE_DISTRICT_CHANGE"]>> = async (
  controller,
  params
) => {
  const selectedDistrict = params.district;
  const cityList = await getCityList(controller, selectedDistrict);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      district: selectedDistrict,
      city: null,
      cityList: cityList,
      zipcode: null,
    },
  }));
};

const HandleCityChange: Handler<Params<Actions["HANDLE_CITY_CHANGE"]>> = async (
  controller,
  params
) => {
  const cityList = controller.getState().PayrollSequence?.cityList;
  const selected = cityList?.find((item: { value: any }) => item.value === params.city);
  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      city: params.city,
      zipcode: selected?.zipcode ?? "",
    },
  }));
};

const FetchLocation: Handler<{
  country?: any;
  province?: any;
  district?: any;
}> = async (controller, params) => {
  const { country, province, district } = params;

  let provinceList = [];
  let districtList = [];
  let cityList = [];

  if (country) {
    provinceList = await getProvinceList(controller, country);
  }

  if (province) {
    districtList = await getDistrictList(controller, province);
  }

  if (district) {
    cityList = await getCityList(controller, district);
  }
  console.log("params:", { country, province, district });

  console.log("Location:", provinceList, districtList, cityList);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      provinceList,
      districtList,
      cityList,
    },
  }));
};

const FetchRevenueItems: Handler = async (controller) => {
  const revenueItems = await getRevenueItems(controller);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      revenueItems: revenueItems,
    },
  }));
};

const HandleSubmitRevenueItem: Handler<Params<Actions["HANDLE_SUBMIT_REVENUE_ITEMS"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_SUBMIT_REVENUE_ITEMS;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const [data, error] = await createRevenueItem(controller, params.item);

  if (data) {
    const revenueItems = await getRevenueItems(controller);

    controller.setState((prev: any) => ({
      PayrollSequence: {
        ...prev.PayrollSequence,
        revenueItems,
      },
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "SUCCESS",
      },
      successMessage: {
        ...prev.successMessage,
        [CARD_NAME]: "Create revenue item successfully",
      },
    }));
  } else {
    controller.setState((prev) => ({
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "ERROR",
      },
      errorMessage: {
        ...prev.errorMessage,
        [CARD_NAME]: error || "Unable to create revenue item",
      },
    }));
  }
};

const HandleEditRevenueItem: Handler<{
  sequence: "Payroll";
  action: "HANDLE_EDIT_REVENUE_ITEMS";
  item: Partial<RevenueItemSerializer>;
}> = async (controller, { item }) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_EDIT_REVENUE_ITEMS;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const { id: pk, ...rest } = item;

  const [data, error] = await RevenueItemEdit.update({
    pk,
    data: rest,
    apiToken: controller.apiToken,
  });

  if (!data) {
    controller.setState((prev) => ({
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "ERROR",
      },
      errorMessage: {
        ...prev.errorMessage,
        [CARD_NAME]: error || "Failed to update revenue item",
      },
    }));
    console.error("Failed to update revenue item", error);
    return;
  }

  const revenueItems = await getRevenueItems(controller);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      revenueItems,
    },
    buttonLoadCheck: {
      ...prev.buttonLoadCheck,
      [actionKey]: "SUCCESS",
    },
    successMessage: {
      ...prev.successMessage,
      [CARD_NAME]: "Update revenue item successfully",
    },
  }));

  console.log("Revenue item updated successfully", data);
};

const FetchDeductItems: Handler = async (controller) => {
  const deductItems = await getDeductItems(controller);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      deductItems: deductItems,
    },
  }));
};

const HandleSubmitDeductItem: Handler<Params<Actions["HANDLE_SUBMIT_DEDUCT_ITEMS"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_SUBMIT_DEDUCT_ITEMS;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const [data, error] = await createDeductItem(controller, params.item);

  if (data) {
    const deductItems = await getDeductItems(controller);

    controller.setState((prev: any) => ({
      PayrollSequence: {
        ...prev.PayrollSequence,
        deductItems,
      },
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "SUCCESS",
      },
      successMessage: {
        ...prev.successMessage,
        [CARD_NAME]: "Create deduct item successfully",
      },
    }));
  } else {
    controller.setState((prev) => ({
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "ERROR",
      },
      errorMessage: {
        ...prev.errorMessage,
        [CARD_NAME]: error || "Unable to create deduct item",
      },
    }));
  }
};

const HandleEditDeductItem: Handler<{
  sequence: "Payroll";
  action: "HANDLE_EDIT_DEDUCT_ITEMS";
  item: Partial<DeductItemSerializer>;
}> = async (controller, { item }) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_EDIT_DEDUCT_ITEMS;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const { id: pk, ...rest } = item;

  const [data, error] = await DeductItemEdit.update({
    pk,
    data: rest,
    apiToken: controller.apiToken,
  });

  if (!data) {
    controller.setState((prev) => ({
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "ERROR",
      },
      errorMessage: {
        ...prev.errorMessage,
        [CARD_NAME]: "Failed to update deduct item",
      },
    }));
    console.error("Failed to update deduct item", error);
    return;
  }

  const deductItems = await getDeductItems(controller);

  controller.setState((prev) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      deductItems,
    },
    buttonLoadCheck: {
      ...prev.buttonLoadCheck,
      [actionKey]: "SUCCESS",
    },
    successMessage: {
      ...prev.successMessage,
      [CARD_NAME]: "Update deduct item successfully",
    },
  }));

  console.log("Deduct item updated successfully", data);
};

const HandleSalaryPayRunReport: Handler<Params<Actions["HANDLE_SALARY_PAY_RUN_REPORT"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_SALARY_PAY_RUN_REPORT;

  const salaryPayRun = params.salaryPayRun;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
      [salaryPayRun]: "LOADING",
    },
  });

  const response = await SalaryPayRunReportPipelineView.get({
    apiToken: controller.apiToken,
    pk: salaryPayRun,
    extra: { responseType: "blob" },
  });

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "SUCCESS",
      [salaryPayRun]: "SUCCESS",
    },
  });

  downloadFile(response[2]);
};

const HandleTaxReport: Handler<Params<Actions["HANDLE_TAX_REPORT"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_TAX_REPORT;

  const salaryPayRun = params.salaryPayRun;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const response = await TaxReportPipelineView.get({
    apiToken: controller.apiToken,
    pk: salaryPayRun,
    extra: { responseType: "blob" },
  });

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "SUCCESS",
    },
  });

  downloadFile(response[2]);
};

const HandleBankPaymentFile: Handler<Params<Actions["HANDLE_BANK_PAYMENT_FILE"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_BANK_PAYMENT_FILE;

  const salaryPayRun = params.salaryPayRun;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const response = await BankPaymentFilePipelineView.get({
    apiToken: controller.apiToken,
    pk: salaryPayRun,
    params: { payment_date: params.paymentDate },
    extra: { responseType: "blob" },
  });

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "SUCCESS",
    },
  });

  downloadFile(response[2]);
};

const HandleSSOReport: Handler<Params<Actions["HANDLE_SSO_REPORT"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_SSO_REPORT;

  const salaryPayRun = params.salaryPayRun;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const response = await SsoReportPipelineView.get({
    apiToken: controller.apiToken,
    pk: salaryPayRun,
    params: { sso_due_date: params.ssoDueDate },
    extra: { responseType: "blob" },
  });

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "SUCCESS",
    },
  });

  downloadFile(response[2]);
};

const HandlePaySlipFile: Handler<Params<Actions["HANDLE_PAY_SLIP_FILE"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();

  const employeePayroll = params.employeePayroll;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [`${employeePayroll}_${params.language}`]: "LOADING",
    },
  });

  const [data] = await EmployeePayrollPaySlip.get({
    apiToken: controller.apiToken,
    pk: employeePayroll,
    params: { language: params.language },
  });

  const pdfMake = await getPdfMake(true);

  const docDefinition = await FormPaySlip({
    ...data,
    language: params.language,
  });

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [`${employeePayroll}_${params.language}`]: null,
    },
  });

  const generatedPdf = pdfMake.createPdf(docDefinition);
  generatedPdf.open();
  setTimeout(() => {
    generatedPdf.download(data["file_name"]);
  }, 1000);
};

const FetchBankList: Handler = async (controller) => {
  const bankList = await getBankList(controller);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      bankList: bankList,
    },
  }));
};

const FetchEmployeePayrollList: Handler = async (controller, params: any) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.FETCH_EMPLOYEE_PAYROLL_LIST;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const {
    startDate = null,
    endDate = null,
    department = null,
    position = null,
    salaryPayRun = null,
  } = params ?? {};

  const response = await getEmployeePayrollList(
    controller,
    startDate,
    endDate,
    department,
    position,
    salaryPayRun
  );

  if (response) {
    controller.setState((prev) => ({
      PayrollSequence: {
        ...prev.PayrollSequence,
        employeePayrollList: response["fields"],
        payrollSummaryParams: response["params"],
        lastSearchFilters: {
          startDate,
          endDate,
          department,
          position,
          salaryPayRun,
        },
      },
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "SUCCESS",
      },
    }));
  } else {
    controller.setState((prev) => ({
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "ERROR",
      },
      errorMessage: {
        ...prev.errorMessage,
        [CARD_NAME]: "Failed to fetch employee payroll list.",
      },
    }));
  }
};

const HandleSubmitBankAccount: Handler<Params<Actions["HANDLE_SUBMIT_BANK_ACCOUNT"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_SUBMIT_BANK_ACCOUNT;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const [created, createError] = await createBankAccount(controller, params.account);

  if (created) {
    const bankAccount = await getBankAccount(controller);

    controller.setState((prev: any) => ({
      PayrollSequence: {
        ...prev.PayrollSequence,
        bankAccount,
      },
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "SUCCESS",
      },
      successMessage: {
        ...prev.successMessage,
        [CARD_NAME]: "Bank account saved successfully.",
      },
      errorMessage: {
        ...prev.errorMessage,
        [CARD_NAME]: null,
      },
    }));
  } else {
    controller.setState((prev: any) => ({
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "ERROR",
      },
      errorMessage: {
        ...prev.errorMessage,
        [CARD_NAME]: createError || { non_field_errors: ["Failed to save bank account."] },
      },
    }));
  }
};

const FetchBankAccountData: Handler = async (controller) => {
  const bankAccount = await getBankAccount(controller);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      bankAccount: bankAccount,
    },
  }));
};

const HandleSubmitDetailSetting: Handler<Params<Actions["HANDLE_SUBMIT_DETAIL_SETTING"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_SUBMIT_DETAIL_SETTING;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const result = await createDetailSetting(controller, params.setting);

  if (result) {
    controller.setState((prev: any) => ({
      PayrollSequence: {
        ...prev.PayrollSequence,
        detailSetting: result,
      },
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "SUCCESS",
      },
      successMessage: {
        ...prev.successMessage,
        [CARD_NAME]: "Detail setting saved successfully.",
      },
    }));
  } else {
    controller.setState((prev) => ({
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "ERROR",
      },
      errorMessage: {
        ...prev.errorMessage,
        [CARD_NAME]: "Failed to save detail setting.",
      },
    }));
  }

  await FetchDetailSetting(controller);
};

const FetchDetailSetting: Handler = async (controller) => {
  const detailSetting = await getDetailSetting(controller);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      detailSetting: detailSetting,
    },
  }));
};

const HandleEditDetailSetting: Handler<{
  sequence: "Payroll";
  action: "HANDLE_EDIT_DETAIL_SETTING";
  setting: Partial<PayrollDetailSettingSerializer>;
}> = async (controller, { setting }) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_EDIT_DETAIL_SETTING;

  const { id: pk, ...rest } = setting;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const [data, error] = await PayrollDetailSettingEdit.update({
    pk,
    data: rest,
    apiToken: controller.apiToken,
  });

  if (!data) {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [actionKey]: "ERROR",
      },
      errorMessage: {
        ...state.errorMessage,
        [CARD_NAME]: "Failed to update detail setting.",
      },
    });
    return;
  }

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      detailSetting: data,
    },
    buttonLoadCheck: {
      ...prev.buttonLoadCheck,
      [actionKey]: "SUCCESS",
    },
    successMessage: {
      ...prev.successMessage,
      [CARD_NAME]: "Detail setting updated successfully.",
    },
  }));

  FetchDetailSetting(controller);
};

const HandleEditEmployeePayroll: Handler<{
  sequence: "Payroll";
  action: "HANDLE_EDIT_EMPLOYEE_PAYROLL";
  item: Partial<EmployeePayrollSerializer> & { id: number };
}> = async (controller, { item }) => {
  const { id, ...rest } = item;

  const [data, error] = await EmployeePayrollEdit.update({
    pk: id,
    data: rest,
    apiToken: controller.apiToken,
  });

  if (!data) {
    console.error("Failed to update employee payroll", error);
    return;
  }

  console.log("Employee payroll updated successfully", data);

  const filters = (controller.getState() as any).PayrollSequence?.lastSearchFilters || {};
  await FetchEmployeePayrollList(controller, filters);

  const state = controller.getState() as any;
  const salaryPayRun = state.PayrollSequence?.salaryPayRun;

  if (salaryPayRun) {
    await HandleSearchEmployeePayroll(controller, {
      sequence: "Payroll",
      action: "HANDLE_SEARCH_EMPLOYEE_PAYROLL",
      salaryPayRun,
    });
  }
};

const HandleSearchEmployeePayroll: Handler<
  Params<Actions["HANDLE_SEARCH_EMPLOYEE_PAYROLL"]>
> = async (controller, params) => {
  const salaryPayRun = params.salaryPayRun;

  console.log("DEBUG:", salaryPayRun);

  const employeePayrollList = await getEmployeePayrollList(
    controller,
    null,
    null,
    null,
    null,
    salaryPayRun
  );

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      salaryPayRun: salaryPayRun,
      searchResultSummary: employeePayrollList["params"],
      searchResultEmployeePayrollList: employeePayrollList["fields"],
    },
  }));
};

const FetchSalaryPayRunList: Handler = async (controller, ...args: any[]) => {
  console.log("fetch salary pay run");
  const [selectedPayRunCode, selectedIssuedDateStart, selectedIssuedDateEnd, selectedStatus] = args;

  const { items, params } = await getSalaryPayRunList(
    controller,
    selectedPayRunCode,
    selectedIssuedDateStart,
    selectedIssuedDateEnd,
    selectedStatus
  );
  console.log("Salary pay run list:", items);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      salaryPayRunList: items ?? [],
      salaryPayRunParams: params ?? {},
    },
  }));
};

const HandleSearchSalaryPayRun: Handler<Params<Actions["HANDLE_SEARCH_SALARY_PAY_RUN"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_SEARCH_SALARY_PAY_RUN;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const selectedPayRunCode = params.payRunCode;
  const selectedIssuedDateStart = params.issuedDateStart;
  const selectedIssuedDateEnd = params.issuedDateEnd;
  const selectedStatus = params.status;
  const onlyAccrued = params.onlyAccrued;

  const response = await getSalaryPayRunList(
    controller,
    selectedPayRunCode,
    selectedIssuedDateStart,
    selectedIssuedDateEnd,
    selectedStatus,
    onlyAccrued
  );

  const salaryPayRunList = Array.isArray(response) ? response : response?.items || [];

  if (
    salaryPayRunList.length > 0 ||
    selectedPayRunCode ||
    selectedIssuedDateStart ||
    selectedIssuedDateEnd ||
    selectedStatus
  ) {
    controller.setState((prev: any) => ({
      PayrollSequence: {
        ...prev.PayrollSequence,
        payRunCode: selectedPayRunCode,
        issuedDateStart: selectedIssuedDateStart,
        issuedDateEnd: selectedIssuedDateEnd,
        status: selectedStatus,
        salaryPayRunList,
      },
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "SUCCESS",
      },
    }));
  } else {
    controller.setState((prev) => ({
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: "ERROR",
      },
      errorMessage: {
        ...prev.errorMessage,
        [CARD_NAME]: "Failed to search salary pay run list.",
      },
    }));
  }
};

const HandleSubmitSalaryPayRun: Handler<Params<Actions["HANDLE_SUBMIT_SALARY_PAY_RUN"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();

  controller.setState((prev) => ({
    buttonLoadCheck: {
      ...prev.buttonLoadCheck,
      [BTN_ACTS.HANDLE_SUBMIT_SALARY_PAY_RUN]: "LOADING",
    },
  }));

  const { data, error } = await createSalaryPayRun(controller, params.salaryPayRun);

  if (!data) {
    controller.setState((prev) => ({
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [BTN_ACTS.HANDLE_SUBMIT_SALARY_PAY_RUN]: "ERROR",
      },
      errorMessage: {
        ...prev.errorMessage,
        [CARD_NAME]: error || "Failed to submit salary pay run",
      },
    }));
    return;
  }

  await FetchEmployeePayrollList(controller);
  await FetchSalaryPayRunList(controller);

  controller.setState((prev) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      salaryPayRun: data,
    },
    buttonLoadCheck: {
      ...prev.buttonLoadCheck,
      [BTN_ACTS.HANDLE_SUBMIT_SALARY_PAY_RUN]: "SUCCESS",
    },
  }));
};

const HandleEditSalaryPayRun: Handler<{
  sequence: "Payroll";
  action: "HANDLE_EDIT_SALARY_PAY_RUN";
  salaryPayRun: Partial<SalaryPayRunSerializer>;
}> = async (controller, { salaryPayRun }) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.HANDLE_EDIT_SALARY_PAY_RUN]: "LOADING",
    },
  });

  const { id: pk, ...rest } = salaryPayRun;

  const [data, error] = await SalaryPayRunEdit.update({
    pk,
    data: rest,
    apiToken: controller.apiToken,
  });

  if (!data) {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [BTN_ACTS.HANDLE_EDIT_SALARY_PAY_RUN]: "ERROR",
      },
      errorMessage: {
        ...state.errorMessage,
        [CARD_NAME]: "Failed to update salary pay run",
      },
    });
    console.error("Failed to update salary pay run", error);
    return;
  }

  await FetchSalaryPayRunList(controller);

  controller.setState((prev: any) => ({
    buttonLoadCheck: {
      ...prev.buttonLoadCheck,
      [BTN_ACTS.HANDLE_EDIT_SALARY_PAY_RUN]: null,
    },
  }));

  console.log("Salary pay run updated successfully", data);
};

const HandleDeleteSalaryPayRun: Handler<{
  sequence: "Payroll";
  action: "HANDLE_DELETE_SALARY_PAY_RUN";
  salaryPayRun: Partial<SalaryPayRunSerializer>;
}> = async (controller, { salaryPayRun }) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_DELETE_SALARY_PAY_RUN;
  const { id: pk } = salaryPayRun;

  if (!pk) {
    console.error("Missing ID for deletion");
    return;
  }

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const [data, error] = await SalaryPayRunEdit.delete({
    pk,
    apiToken: controller.apiToken,
  });

  if (error) {
    console.error("Failed to delete salary pay run", error);
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [actionKey]: "ERROR",
      },
      errorMessage: {
        ...state.errorMessage,
        Payroll: "Failed to delete salary pay run",
      },
    });
    return;
  }

  console.log("Salary pay run deleted successfully", data);
  await FetchSalaryPayRunList(controller);

  controller.setState((prev) => ({
    buttonLoadCheck: {
      ...prev.buttonLoadCheck,
      [actionKey]: "SUCCESS",
    },
    successMessage: {
      ...prev.successMessage,
      Payroll: "Salary pay run deleted successfully",
    },
  }));

  setTimeout(() => {
    controller.setState((prev) => ({
      buttonLoadCheck: {
        ...prev.buttonLoadCheck,
        [actionKey]: null,
      },
    }));
  }, 1000);
};

const FetchPaidSalary: Handler<{ pk?: number | string }> = async (controller, params) => {
  const { pk } = params;

  const { items, params: salaryParams } = await getPaidSalary(controller, pk);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      paidSalaryList: items ?? [],
      paidSalaryParams: salaryParams ?? {},
    },
  }));
};

const HandleSubmitPaidSalary: Handler<Params<Actions["HANDLE_SUBMIT_PAID_SALARY"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();
  const actionKey = BTN_ACTS.HANDLE_SUBMIT_PAID_SALARY;

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [actionKey]: "LOADING",
    },
  });

  const result = await createPaidSalary(controller, params.paidSalaryData);

  if (!result) {
    console.error("No result returned from createPaidSalary");
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [actionKey]: "ERROR",
      },
      errorMessage: {
        ...state.errorMessage,
        [CARD_NAME]: "Failed to submit paid salary data.",
      },
    });
    return;
  }

  await FetchPaidSalary(controller, { pk: params.paidSalaryData.salary_pay_run });
  await FetchSalaryPayRunList(controller);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      paidSalaryData: result,
    },
    buttonLoadCheck: {
      ...prev.buttonLoadCheck,
      [actionKey]: "SUCCESS",
    },
  }));
};

const FetchPaidSSO: Handler<{
  sequence: "Payroll";
  action: "FETCH_PAID_SSO";
  pk?: number | string;
}> = async (controller, params) => {
  const { pk } = params;

  const { items, params: apiParams } = await getPaidSSO(controller, pk);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      paidSSOList: items ?? [],
      paidSSOParams: apiParams ?? {},
    },
  }));

  console.log("Get Paid SSO", items, params);
};

const HandleSubmitPaidSSO: Handler<Params<Actions["HANDLE_SUBMIT_PAID_SSO"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.HANDLE_SUBMIT_PAID_SSO]: "LOADING",
    },
  });

  const result = await createPaidSSO(controller, params.paidSSOData);

  if (!result) {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [BTN_ACTS.HANDLE_SUBMIT_PAID_SSO]: "ERROR",
      },
      errorMessage: {
        ...state.errorMessage,
        [CARD_NAME]: "Failed to submit paid salary data",
      },
    });
    return;
  }

  await FetchSalaryPayRunList(controller);

  await FetchPaidSSO(controller, {
    sequence: "Payroll",
    action: "FETCH_PAID_SSO",
    pk: params.paidSSOData.salary_pay_run,
  });

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      paidSSOData: result,
    },
    buttonLoadCheck: {
      ...prev.buttonLoadCheck,
      [BTN_ACTS.HANDLE_SUBMIT_PAID_SSO]: "SUCCESS",
    },
  }));
};

const HandleSubmitRecordAccrued: Handler<Params<Actions["HANDLE_SUBMIT_RECORD_ACCRUED"]>> = async (
  controller,
  params
) => {
  const state = controller.getState();

  controller.setState({
    buttonLoadCheck: {
      ...state.buttonLoadCheck,
      [BTN_ACTS.HANDLE_SUBMIT_RECORD_ACCRUED]: "LOADING",
    },
  });

  const { salaryPayRunId, accruedData } = params;

  const result = await createRecordAccrued(controller, salaryPayRunId, accruedData);

  if (!result) {
    controller.setState({
      buttonLoadCheck: {
        ...state.buttonLoadCheck,
        [BTN_ACTS.HANDLE_SUBMIT_RECORD_ACCRUED]: "ERROR",
      },
      errorMessage: {
        ...state.errorMessage,
        [CARD_NAME]: "Failed to submit record accrued data",
      },
    });
    return;
  }

  await FetchSalaryPayRunList(controller);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      recordAccruedData: result,
    },
    buttonLoadCheck: {
      ...prev.buttonLoadCheck,
      [BTN_ACTS.HANDLE_SUBMIT_RECORD_ACCRUED]: "SUCCESS",
    },
    successMessage: {
      ...state.successMessage,
      [CARD_NAME]: "Record accrued created successfully",
    },
  }));
};

const FetchUserList: Handler<{
  sequence: "Payroll";
  action: "FETCH_USER_LIST";
  pk?: number | string;
}> = async (controller, params) => {
  const { pk } = params;
  console.log("Fetched User by ID:", pk);

  const { items, params: apiParams } = await getUserList(controller, pk);

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      userDetail: items ?? [],
      userDetailParams: apiParams ?? {},
    },
  }));

  console.log("Fetched User by ID:", items);
};

const FetchPayrollRecordList: Handler<{
  sequence: "Payroll";
  action: "FETCH_PAYROLL_RECORD_LIST";
}> = async (controller, _args) => {
  const apiToken = controller.apiToken;

  const [data, err] = await PayrollRecordList.list({ apiToken });

  if (err) {
    console.error("Failed to fetch PayrollRecordList:", err);
    return;
  }

  const items = data?.items ?? [];

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      payrollRecordList: items,
    },
  }));

  console.log("Fetched PayrollRecordList:", items);
};

const FetchClinicalTermSetList: Handler<{
  sequence: "Payroll";
  action: "FETCH_CLINICAL_TERM_SET_LIST";
}> = async (controller) => {
  const apiToken = controller.apiToken;

  const [data, err] = await ClinicalTermSetView.post({
    apiToken,
    data: { question: ["salary_payrun_cancel"] },
  });

  if (err) {
    console.error("Failed to fetch ClinicalTermSetList:", err);
    return;
  }

  const items = data ?? [];

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      clinicalTermSetList: items,
    },
  }));

  console.log("Fetched ClinicalTermSetList (salary_payrun_cancel):", items);
};

const FetchSalaryPayRunUpdateLogList: Handler<{
  sequence: "Payroll";
  action: "FETCH_SALARY_PAYRUN_UPDATE_LOG_LIST";
  salaryPayRun?: number | string;
}> = async (controller, args) => {
  const apiToken = controller.apiToken;

  const params = args?.salaryPayRun ? { salary_pay_run: args.salaryPayRun } : undefined;

  const [data, err] = await SalaryPayRunUpdateLogList.list({ apiToken, params });

  if (err) {
    console.error("Failed to fetch SalaryPayRunUpdateLogList:", err);
    return;
  }

  const items = data?.items ?? [];

  controller.setState((prev: any) => ({
    PayrollSequence: {
      ...prev.PayrollSequence,
      salaryPayRunUpdateLogList: items,
    },
  }));

  console.log("Fetched SalaryPayRunUpdateLogList:", items);
};

/** ====================================================  */
/**                         Utils                         */
/** ====================================================  */

const getProvinceList = async (controller: any, selectedCountry: any) => {
  const data = await ProvinceList.list({
    apiToken: controller.apiToken,
    params: {
      area: selectedCountry,
    },
  });

  if (data) {
    const nameField = "name";
    const options = data[0].items.map((item: { [x: string]: any; id: any }) => ({
      id: item.id,
      text: item[nameField],
      value: item.id,
    }));

    return options;
  }
};

const getDistrictList = async (controller: any, selectedProvince: any) => {
  const data = await DistrictList.list({
    apiToken: controller.apiToken,
    params: {
      area: selectedProvince,
    },
  });

  if (data) {
    const nameField = "name";
    const options = data[0].items.map((item: { [x: string]: any; id: any }) => ({
      id: item.id,
      text: item[nameField],
      value: item.id,
    }));

    return options;
  }
};

const getCityList = async (controller: any, selectedDistrict: any) => {
  const data = await CityList.list({
    apiToken: controller.apiToken,
    params: {
      area: selectedDistrict,
    },
  });

  if (data) {
    const options = data[0].items.map((item: { id: any; zipcode: any; name: string }) => ({
      id: item.id,
      text: item.name,
      value: item.id,
      zipcode: item.zipcode,
    }));

    return options;
  }
};

const getRevenueItems = async (controller: any) => {
  const [data, error] = await RevenueItemList.list({
    apiToken: controller.apiToken,
  });

  if (!data) {
    console.error("Failed to get revenue item:", error);
    return [];
  }
  console.log("BUG", data);
  return data.items;
};

const createRevenueItem = async (
  controller: any,
  item: Partial<RevenueItemSerializer>
): Promise<[RevenueItemSerializer | null, any]> => {
  const [data, error] = await RevenueItemList.create({
    data: item,
    apiToken: controller.apiToken,
  });

  if (!data) {
    console.error("Failed to create revenue item:", error);
    return [null, error];
  }

  return [data, null];
};

const getDeductItems = async (controller: any) => {
  const [data, error] = await DeductItemList.list({
    apiToken: controller.apiToken,
  });

  if (!data) {
    console.error("Failed to get deduct item:", error);
    return [];
  }
  console.log("BUG", data);
  return data.items;
};

const createDeductItem = async (controller: any, item: Partial<DeductItemSerializer>) => {
  const [data, error] = await DeductItemList.create({
    data: item,
    apiToken: controller.apiToken,
  });

  if (!data) {
    console.error("Failed to create deduct item:", error);
    return [null, error];
  }

  return [data, null];
};

const getBankList = async (controller: any) => {
  const data = await BankList.list({
    apiToken: controller.apiToken,
  });

  if (!data) {
    console.error("Failed to get bank list");
    return [];
  }
  console.log("BUG", data);
  return data[0].items;
};

const getEmployeePayrollList = async (
  controller: any,
  selectedStartDate?: any,
  selectedEndDate?: any,
  selectedDepartment?: any,
  selectedPosition?: any,
  salaryPayRun?: any
) => {
  const params = {
    start_date: selectedStartDate ?? null,
    end_date: selectedEndDate ?? null,
    department: selectedDepartment ?? null,
    position: selectedPosition ?? null,
    salary_pay_run: salaryPayRun ?? null,
  };

  const [response, error, meta] = await EmployeePayrollList.get({
    apiToken: controller.apiToken,
    params,
  });

  if (error) {
    console.error("API error:", error);
  }

  if (!response) {
    console.error("Failed to get employee payroll list, response is null");
    return { fields: [], params: {} };
  }

  console.log("Employee Payroll Response:", response);

  return {
    fields: response.fields ?? [],
    params: response.params ?? {},
  };
};

const getBankAccount = async (controller: any) => {
  const data = await OrganizationBankAccountCreate.list({
    apiToken: controller.apiToken,
  });

  if (!data) {
    console.error("Failed to get bank list");
    return [];
  }
  console.log("BUG", data);
  return data[0].items;
};

const createBankAccount = async (
  controller: any,
  item: Partial<OrganizationBankAccountSerializer>
): Promise<[any, any]> => {
  const [data, error] = await OrganizationBankAccountCreate.create({
    data: item,
    apiToken: controller.apiToken,
  });

  if (error || !data) {
    console.error("Failed to create bank account:", error);
    return [null, error];
  }

  return [data, null];
};

const getDetailSetting = async (controller: any) => {
  const data = await PayrollDetailSetting.list({
    apiToken: controller.apiToken,
  });

  if (!data) {
    console.error("Failed to get bank list");
    return [];
  }
  console.log("BUG", data);
  return data[0].items;
};

const createDetailSetting = async (
  controller: any,
  item: Partial<PayrollDetailSettingSerializer>
) => {
  const [data, error] = await PayrollDetailSetting.create({
    data: item,
    apiToken: controller.apiToken,
  });

  if (error || !data) {
    console.error("Failed to create payroll detail setting", error);
    return null;
  }

  return [data];
};

const createSalaryPayRun = async (
  controller: any,
  salaryPayRun: Partial<SalaryPayRunSerializer>
) => {
  const [data, error] = await SalaryPayRunList.create({
    data: salaryPayRun,
    apiToken: controller.apiToken,
  });

  if (error || !data) {
    console.error("Failed to create salary pay run", error);
    return { data: null, error };
  }

  console.log("Create Salary pay run successfully", [data]);
  return { data, error: null };
};

const getSalaryPayRunList = async (
  controller: any,
  selectedPayRunCode: any,
  selectedIssuedDateStart: any,
  selectedIssuedDateEnd: any,
  selectedStatus: any,
  onlyAccrued: any = "false"
) => {
  const [response, _, meta] = await SalaryPayRunList.list({
    apiToken: controller.apiToken,
    params: {
      pay_run_code: selectedPayRunCode,
      issued_date_start: selectedIssuedDateStart,
      issued_date_end: selectedIssuedDateEnd,
      status: selectedStatus,
      only_accrued: onlyAccrued,
    },
  });

  if (!response) {
    console.error("Failed to get salary pay run list");
    return { items: [], params: {} };
  }

  console.log("Salary Pay Run Response:", response);
  console.log("salary items", response.items);

  return {
    items: response.items ?? [],
    params: response.params ?? {},
  };
};

const createPaidSalary = async (
  controller: any,
  paidSalaryData: Partial<FileToBankSerializer> & { salary_pay_run: number | string }
) => {
  const pk = paidSalaryData.salary_pay_run;

  if (!pk) {
    console.error("Missing salary_pay_run (pk) for createPaidSalary");
    return null;
  }

  const { salary_pay_run, ...dataWithoutId } = paidSalaryData;

  const [data, error] = await SalaryPayRunConfirmPaidSalary.post({
    pk,
    data: dataWithoutId,
    apiToken: controller.apiToken,
  });

  if (error || !data) {
    console.error("Failed to create paid salary", error);
    return null;
  }

  console.log("Create Paid Salary successfully", data);
  return data;
};

const getPaidSalary = async (controller: any, pk?: number | string) => {
  const [response, error, meta] = await SalaryPayRunConfirmPaidSalary.get({
    pk,
    apiToken: controller.apiToken,
  });

  if (!response) {
    return { items: [], params: {} };
  }

  console.log("Paid Salary Response:", response);
  return {
    items: response.items ?? [],
    params: response.params ?? {},
  };
};

const createPaidSSO = async (
  controller: any,
  paidSSOData: Partial<PaidSSOSerializer> & { pay_run_id: number | string }
) => {
  const pk = paidSSOData.salary_pay_run;

  if (!pk) {
    console.error("Missing salary_pay_run (pk) for createPaidSSO");
    return null;
  }

  const { salary_pay_run, ...dataWithoutId } = paidSSOData;

  const [data, error] = await SalaryPayRunConfirmPaidSSO.post({
    pk,
    data: dataWithoutId,
    apiToken: controller.apiToken,
  });

  if (error || !data) {
    console.error("Failed to create paid SSO", error);
    return null;
  }

  console.log("Create Paid SSO successfully", data);
  return data;
};

const createRecordAccrued = async (
  controller: any,
  salaryPayRunId: number | string,
  params?: any
) => {
  if (!salaryPayRunId) {
    console.error("Missing salary_pay_run id");
    return null;
  }

  const data = {};

  const [responseData, error] = await SalaryPayRunRecordAccrued.post({
    pk: salaryPayRunId,
    data,
    params,
    apiToken: controller.apiToken,
  });

  if (error || !responseData) {
    console.error("Failed to create record accrued", error);
    return null;
  }

  console.log("Record accrued created successfully", responseData);
  return responseData;
};

const getPaidSSO = async (
  controller: any,
  pk?: number | string
): Promise<{ items: any[]; params: any }> => {
  const [response, error] = await PaidSSOList.list({
    params: pk ? { salary_pay_run: pk } : {},
    apiToken: controller.apiToken,
  });

  if (!response) {
    console.error("Failed to get paid SSO data:", error);
    return { items: [], params: {} };
  }

  console.log("Paid SSO Response:", response);
  return {
    items: response.items ?? [],
    params: response.params ?? {},
  };
};

const getUserList = async (
  controller: any,
  pk?: number | string
): Promise<{ items: any[]; params: any }> => {
  if (!pk) {
    console.error("No user pk provided");
    return { items: [], params: {} };
  }

  const [response, error] = await UserList.list({
    params: { pk },
    apiToken: controller.apiToken,
  });

  if (error || !response) {
    console.error("Failed to get user by pk:", error);
    return { items: [], params: {} };
  }

  console.log("User detail response:", response);

  return {
    items: response.items ?? [],
    params: response.params ?? {},
  };
};
